import { useWindowSize } from 'hooks/useWindowSize';

import React, { forwardRef } from 'react';

import { Button } from '@thinkific/chalk/Button';
import type { ButtonProps } from '@thinkific/chalk/Button';
import type { Icon } from '@thinkific/chalk/react-icons';

import * as css from './ActionButton.css';

export interface ActionButtonProps extends Omit<ButtonProps, 'children'> {
  isActive: boolean;
  disabled: boolean;
  icon: Icon;
  arialLabel: string;
  className?: string;
}

export const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
  function ActionButtonReffed(
    { icon, isActive, disabled, onClick, arialLabel, className, ...props }: ActionButtonProps,
    ref
  ) {
    const { isMobile } = useWindowSize();
    return (
      <Button
        {...props}
        className={`${className} ${css.button}`}
        disabled={disabled}
        emphasis="low"
        icon={icon}
        pressed={isActive}
        ref={ref}
        size={isMobile ? 'xs' : 'sm'}
        type="button"
        variant="default"
        hiddenLabel
        onClick={(e) => !disabled && onClick?.(e)}
      >
        {arialLabel}
      </Button>
    );
  }
);
export default ActionButton;
